import { useEffect, useRef } from "react";

export function useWakeLock(enabled) {
  const lock = useRef(null);
  useEffect(() => {
    if (!enabled || !("wakeLock" in navigator)) return undefined;
    let released = false;
    const acquire = async () => {
      try {
        lock.current = await navigator.wakeLock.request("screen");
      } catch {
        /* not permitted */
      }
    };
    const onVis = () => document.visibilityState === "visible" && !released && acquire();
    acquire();
    document.addEventListener("visibilitychange", onVis);
    return () => {
      released = true;
      document.removeEventListener("visibilitychange", onVis);
      lock.current?.release?.();
    };
  }, [enabled]);
}
